import React from 'react';
import {
  FaPlus,
  FaMapMarkerAlt,
  FaUser,
  FaEdit,
  FaTrash,
  FaBuilding,
} from 'react-icons/fa';
import { ProjectSite } from '../../operations/services/PlantafelService';
import styles from './ProjectDetailPage.module.css';

interface ProjectSitesTabProps {
  sites: ProjectSite[];
  sitesLoading: boolean;
  deletingSiteId: number | null;
  onCreateSite: () => void;
  onEditSite: (site: ProjectSite) => void;
  onDeleteSite: (siteId: number) => void;
}

export function ProjectSitesTab({
  sites,
  sitesLoading,
  deletingSiteId,
  onCreateSite,
  onEditSite,
  onDeleteSite,
}: ProjectSitesTabProps): React.JSX.Element {
  return (
    <div>
      <div className={styles.tabHeader}>
        <h3 className={styles.tabTitle}>Standorte ({sites.length})</h3>
        <button onClick={onCreateSite} className={styles.primaryButton}>
          <FaPlus size={12} />
          Site hinzufügen
        </button>
      </div>

      {sitesLoading ? (
        <div className={styles.loadingState}>Laden...</div>
      ) : sites.length === 0 ? (
        <div className={styles.emptyState}>
          <FaBuilding size={40} color="#ccc" className={styles.emptyStateIcon} />
          <p className={styles.emptyStateText}>Noch keine Sites angelegt</p>
          <button onClick={onCreateSite} className={styles.primaryButtonLg}>
            <FaPlus size={12} />
            Erste Site erstellen
          </button>
        </div>
      ) : (
        <div className={styles.sitesGrid}>
          {sites.map((site) => (
            <div key={site.id} className={styles.siteCard}>
              <div className={styles.siteCardHeader}>
                <h4 className={styles.siteCardName}>{site.name}</h4>
                <div className={styles.iconButtonGroup}>
                  <button
                    onClick={() => onEditSite(site)}
                    className={styles.editIconButton}
                    title="Bearbeiten"
                  >
                    <FaEdit size={12} />
                  </button>
                  <button
                    onClick={() => onDeleteSite(site.id)}
                    disabled={deletingSiteId === site.id}
                    className={styles.deleteIconButton}
                    style={{
                      cursor: deletingSiteId === site.id ? 'not-allowed' : 'pointer',
                      opacity: deletingSiteId === site.id ? 0.5 : 1,
                    }}
                    title="Löschen"
                  >
                    <FaTrash size={12} />
                  </button>
                </div>
              </div>

              {site.address && (
                <div className={styles.siteAddress}>
                  <FaMapMarkerAlt size={12} style={{ marginTop: '2px', flexShrink: 0 }} />
                  <span>{site.address}</span>
                </div>
              )}

              {site.contact_name && (
                <div className={styles.siteContact}>
                  <FaUser size={12} />
                  <span>{site.contact_name}</span>
                  {site.contact_phone && (
                    <span style={{ color: '#888' }}>({site.contact_phone})</span>
                  )}
                </div>
              )}

              {(site.access_info || site.parking_info) && (
                <div className={styles.siteExtraInfo}>
                  {site.access_info && (
                    <div>
                      <strong>Zugang:</strong> {site.access_info}
                    </div>
                  )}
                  {site.parking_info && (
                    <div>
                      <strong>Parken:</strong> {site.parking_info}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
